import React, { useState } from "react";
import { Box } from "@mui/material";
import Sidebar from "../components/Sidebar";
import AppBarComponent from "../components/Appbar";
import ChatArea from "../components/ChatArea";

const MainPage: React.FC = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <Box
      display="flex"
      height="100vh"
      sx={{
        overflowY: "scroll",
        msOverflowStyle: "none", // Hide scrollbar in Internet Explorer and Edge
        scrollbarWidth: "none", // Hide scrollbar in Firefox
        "&::-webkit-scrollbar": { display: "none" }, // Hide scrollbar in WebKit browsers
      }}
    >
      <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      <Box flex={1} display="flex" flexDirection="column">
        <AppBarComponent
          toggleSidebar={toggleSidebar}
          isSidebarOpen={isSidebarOpen}
        />
        <ChatArea />
      </Box>
    </Box>
  );
};

export default MainPage;
